import React, { useState, useEffect } from "react";
import { Container, StyledInput } from "./styles";
import { string, func, oneOf, bool } from "prop-types";
import { Error } from "components/shared/form";
import { connect } from "formik";
import Label from "components/label";

const Input = ({
  placeholder,
  label,
  type,
  name,
  formik,
  value = formik.values[name],
  onChange = formik.handleChange,
  onBlur = formik.handleBlur,
  disabled,
  ...rest
}) => {
  const [populated, setPopulated] = useState(!!value);

  useEffect(() => {
    setPopulated(!!value);
  }, [value]);

  function handleChange(e) {
    setPopulated(!!e.target.value);
    onChange(e);
  }

  const { errors, touched, values } = formik;
  const attrs = { placeholder, type, name, value, onBlur, disabled, ...rest };
  return (
    <Container>
      <Label visible={values[name]} label={label || placeholder} />
      <StyledInput populated={populated} onChange={handleChange} {...attrs} />
      {errors[name] && touched[name] && <Error>{errors[name]}</Error>}
    </Container>
  );
};

export default connect(Input);

Input.defaultProps = {
  placeholder: "",
  label: "",
  name: "",
  disabled: false,
};

Input.propTypes = {
  placeholder: string,
  label: string,
  type: oneOf(["text", "input", "search", "password"]),
  name: string,
  value: string,
  onChange: func,
  onBlur: func,
  disabled: bool,
};
